import { EMPTY_VALUE_LABEL } from 'consts/labels/common';
import { AppParagraph } from 'components/atoms';

export type DietPriceDisplayProps = {
    value: number | null;
    showEmptyValue?: boolean;
};

export const PriceDisplay = ({ value, showEmptyValue = true }: DietPriceDisplayProps) => {
    const parsedValue = showEmptyValue ? value : value ?? 0;
    const priceText = parsedValue
        ? `${parsedValue.toLocaleString('pl-PL', { minimumFractionDigits: 2 })} zł`
        : EMPTY_VALUE_LABEL;

    return <AppParagraph margin={0}>{priceText}</AppParagraph>;
};
